import { Row } from '../../../../../design-system/components/grid/grid';
import { MarketingTab } from '../Marketing.page';
import { Card } from '../../../components/Card';
import { WelcomeScreen } from './WelcomeScreen';
import { CampaignDetails, CampaignDetailsProps } from './CampaignDetails';

export type CampaignSetupProps = CampaignDetailsProps & {
  changeTab: (v: MarketingTab) => void;
  started: boolean;
  setStarted: (v: boolean) => void;
};

export const CampaignSetup = ({
  started,
  setStarted,
  changeTab,
  ...p
}: CampaignSetupProps) => (
  <Card
    variant="basic"
    className="p-[48px]"
    style={{
      ...(started
        ? {}
        : {
            background: `white url('/static/images/marketing/campaign-welcome.png') no-repeat`,
            backgroundPosition: 'left 520px center',
            backgroundSize: '1080px',
          }),
    }}
  >
    <Row>
      <div style={{ minHeight: '600px', maxWidth: '420px' }}>
        {!started ? (
          <WelcomeScreen setStarted={setStarted} changeTab={changeTab} />
        ) : (
          <CampaignDetails {...p} />
        )}
      </div>
    </Row>
  </Card>
);
